import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbItemClickEvent, BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';

import { DesignPanelsHelperService } from '@offconon/shared/utils/services/design-panels-helper';

@Component({
  selector: 'offconon-erp-module-header',
  imports: [
    CommonModule,
    BreadcrumbModule,
    ButtonModule,
    TranslateModule,
    BreadcrumbModule,
    RouterModule,
  ],
  templateUrl: './erp-module-header.component.html',
  styles: ``,
})
export class ErpModuleHeaderComponent implements OnInit, OnChanges {
  @Input() moduleData: {
    menuItems?: MenuItem[];
    title: string;
    subtitle: string;
    backgroundImage: string;
  };
  @Input() rbac_enum_check = false;

  wg_title: any;
  background_image: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['moduleData']) {
      this.background_image = this.moduleData?.backgroundImage
        ? this.moduleData?.backgroundImage
        : null;
      this.wg_title = null;
    }
  }

  private router = inject(Router);
  private designPanelsHelperService = inject(DesignPanelsHelperService);
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.background_image = this.moduleData?.backgroundImage
      ? this.moduleData?.backgroundImage
      : null;
    this.wg_title = null;

    this.designPanelsHelperService.taskWorkgroupData$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (postData: any) => {
          if (postData && postData?.system_data?.title) {
            this.wg_title = postData?.system_data?.title;
          }
        },
      });

    if (this.rbac_enum_check) {
      this.designPanelsHelperService.rbacData$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (postData: any) => {
          if (postData) {
            this.moduleData.subtitle = postData?.module_name;
          }
        },
      });
    }
  }

  navigateItem(event: BreadcrumbItemClickEvent) {
    this.router.navigate([event.item['route']]);
  }
}
